import React, { useState, useRef, useEffect } from "react";
import { Alert, Button, Form } from "react-bootstrap";
import { POST, GET } from "../Database/RealtimeDatabase";
import { GetSkillFileNames, GetSkillImage } from "../Database/Functions";
import Header from "../UI/Header/Header";
import IconList from "../UI/IconList/IconList";
import Icon from "../UI/Icon/Icon";

export default function ServicePageSkills() {
  const [alert, setAlert] = useState();
  const [loadingskills, setIsLoadingskills] = useState(false);
  const [skills, setskills] = useState([]);
  const [hasUpdates, setHasUpdates] = useState(false);
  const skillRef = useRef();
  const skillIconRef = useRef();

  const skillIcons = GetSkillFileNames();

  const submitskillsHandler = () => {
    setAlert(false);
    const newskill = {
      name: skillRef.current.value,
      icon: skillIconRef.current.value,
    };
    POST(newskill, "skills").then(() => {
      setAlert(newskill.name + " добавлена");
      setHasUpdates(true);
    });
  };

  //Load skills
  useEffect(() => {
    setIsLoadingskills(true);
    GET("skills").then((items) => {
      setIsLoadingskills(false);
      setskills(items);
      setHasUpdates(false);
    });
  }, [hasUpdates]);

  return (
    <>
      <Form className="Form">
        <Form.Group className="Form__group">
          <Header>Скилы</Header>
          <p>Каталог скилов, котрые отображаются на радаре.</p>
          <h4>Доступные:</h4>
          <IconList layout="vertical">
            {skills.map((skill,i) => (
              <Icon image={skill.icon} title={skill.name} className="List__item" size="s" key={i}/>
            ))}
          </IconList>
          <br/>

          <h4>Добавить новый</h4>
          <Form.Control
            type="text"
            ref={skillRef}
            required
            placeholder="Название скила"
          />
          <Form.Select ref={skillIconRef}>
            {skillIcons.map((icon, i) => (
              <option value={icon} key={i}>
                {icon}
              </option>
            ))}
          </Form.Select>
          <Button onClick={submitskillsHandler} className="Form__submit">
            Добавить скил
          </Button>
        </Form.Group>
      </Form>
      {alert && <Alert variant="success">{alert}</Alert>}
    </>
  );
}
